module.exports = __webpack_public_path__ + "static/media/SNOB3P.84c3eef9.png";